// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__lvy7E","logo":"styles_logo__aBg1L","mainText":"styles_mainText__0dlhS","desc":"styles_desc__80XhB"};